var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcMax(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 9,
    viewBox: "0 0 24 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.54688 0.846436L4.80273 6.84057L7.05322 0.846436H8.80957V8.66675H7.45605V6.08862L7.59033 2.64038L5.28076 8.66675H4.30859L2.00439 2.64575L2.13867 6.08862V8.66675H0.785156V0.846436H2.54688Z",
    fill: "#0066DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.895 6.84595H11.8657L11.2319 8.66675H9.81934L12.7734 0.846436H13.9927L16.9521 8.66675H15.5342L14.895 6.84595ZM12.2471 5.75024H14.5137L13.3804 2.5061L12.2471 5.75024Z",
    fill: "#0066DA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5347 3.67163L22.1782 0.846436H23.7466L21.3833 4.72436L23.8003 8.66675H22.2158L20.5347 5.79858L18.8481 8.66675H17.269L19.6914 4.72436L17.3228 0.846436H18.8911L20.5347 3.67163Z",
    fill: "#0066DA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMax);
export default __webpack_public_path__ + "static/media/ic_max.b10dbb88.svg";
export { ForwardRef as ReactComponent };